import { render } from "./FormPanels.vue?vue&type=template&id=0681f7de&ts=true"
import script from "./FormPanels.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormPanels.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/FormPanels.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0681f7de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0681f7de', __exports__)) {
    console.log('reload')
    api.reload('0681f7de', __exports__)
  }
  
  module.hot.accept("./FormPanels.vue?vue&type=template&id=0681f7de&ts=true", () => {
    console.log('re-render')
    api.rerender('0681f7de', render)
  })

}


export default __exports__